module.exports = __webpack_public_path__ + "../../../static/img/c_im_26.a04e270a.png";